import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import About from './components/About';
import Members from './components/Members';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ContactUs from './components/ContactUs';

function App() {
  return (
    <>
    <Router>
    <Navbar />
    <Routes>
    <Route path="/" element={<Home/>} exact />
    <Route path="/about" element={<About/>}  />
    <Route path="/members" element={<Members/>}  />
    <Route path="/ContactUs" element={<ContactUs/>}  />
    </Routes>
    </Router>
    </>
  );
}

export default App;
